import {PayAPI} from 'apis/PayApi';
import {useEffect, useState} from 'react';
import {toast} from 'react-hot-toast';
import {useSearchParams} from 'react-router-dom';
import GeneralBackref from './GeneralBackref';

function VivaPayBackref() {
  // eslint-disable-next-line
  const [searchParams] = useSearchParams();

  const [orderUUID, setOrderUUID] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(null);
  const [orderCode, setOrderCode] = useState(null);
  const [transactionID, setTransactionID] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (orderCode != null) {
      PayAPI.queryOkePay('viva', orderCode).then((res) => {
        if (res.success) {
          setOrderUUID(res.data.extID);
          setLoaded(true);
        } else {
          console.log(res);
          setLoaded(true);
          toast.error('Error!');
        }
      });
    }
    // eslint-disable-next-line
  }, [orderCode]);

  useEffect(() => {
    try {
      let eventId = searchParams.get('eventId');
      let transactionId = searchParams.get('t');
      setTransactionID(transactionId);
      let code = searchParams.get('s');
      setOrderCode(code);

      if (eventId === '0' && transactionId != null) {
        setPaymentSuccess(true);
      } else setPaymentSuccess(false);
    } catch (e) {
      console.log('error');
      setPaymentSuccess(false);
    }
    // eslint-disable-next-line
  }, []);

  return <GeneralBackref loading={!loaded || paymentSuccess == null || orderUUID == null} success={paymentSuccess} transactionID={transactionID} orderUUID={orderUUID} paymentAgent={'VivaPay'} />;
}

export default VivaPayBackref;
